module.exports = __webpack_public_path__ + "img/agent.3816661f.png";